import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=78ded1b8&scoped=true"
import script from "./productList.vue?vue&type=script&lang=ts"
export * from "./productList.vue?vue&type=script&lang=ts"
import style0 from "./productList.vue?vue&type=style&index=0&id=78ded1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ded1b8",
  null
  
)

export default component.exports